export default __webpack_public_path__ + "static/media/Avalanche.82c631e8.png";